import React from "react";
import { Link } from "wouter";

/**
 * Blog içeriği için bağımlılıksız, hafif Markdown işleyici.
 * Destekler: ## başlık, sırasız (-) ve sıralı (1.) listeler, **kalın**,
 * [bağlantı](url) ve paragraflar. Blog yazıları bu alt kümede yazılır.
 */

function satiriIsle(text: string, keyBase: string): React.ReactNode[] {
  const parcalar: React.ReactNode[] = [];
  // **kalın** ve [metin](url) desenlerini birlikte yakala
  const regex = /\*\*(.+?)\*\*|\[([^\]]+)\]\(([^)]+)\)/g;
  let son = 0;
  let m: RegExpExecArray | null;
  let i = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > son) parcalar.push(text.slice(son, m.index));
    if (m[1] !== undefined) {
      parcalar.push(<strong key={`${keyBase}-b${i}`} className="text-[#0A1A3F] font-bold">{m[1]}</strong>);
    } else {
      const href = m[3];
      const ic = href.startsWith("/");
      parcalar.push(
        ic ? (
          <Link key={`${keyBase}-a${i}`} href={href} className="text-[#0A1A3F] font-bold underline decoration-[#6B8AFE] decoration-2 hover:text-[#6B8AFE]">
            {m[2]}
          </Link>
        ) : (
          <a key={`${keyBase}-a${i}`} href={href} target="_blank" rel="noopener" className="text-[#0A1A3F] font-bold underline decoration-[#6B8AFE] decoration-2 hover:text-[#6B8AFE]">
            {m[2]}
          </a>
        )
      );
    }
    son = m.index + m[0].length;
    i++;
  }
  if (son < text.length) parcalar.push(text.slice(son));
  return parcalar;
}

export function MarkdownIcerik({ content }: { content: string }) {
  const bloklar = content.split(/\n\n+/);
  return (
    <div className="space-y-5 min-w-0 break-words">
      {bloklar.map((blok, bi) => {
        const b = blok.trim();
        if (!b) return null;
        if (b.startsWith("## ")) {
          return (
            <h2 key={bi} className="text-2xl lg:text-3xl font-black text-[#0A1A3F] tracking-tight pt-4 pb-1 border-b-3 border-[#6B8AFE] inline-block max-w-full">
              {satiriIsle(b.slice(3), `h${bi}`)}
            </h2>
          );
        }
        const satirlar = b.split("\n").map(s => s.trim()).filter(Boolean);
        const hepsiListe = satirlar.every(s => s.startsWith("- "));
        const hepsiSirali = satirlar.every(s => /^\d+\.\s/.test(s));
        if (hepsiListe) {
          return (
            <ul key={bi} className="space-y-2 pl-1">
              {satirlar.map((s, li) => (
                <li key={li} className="flex gap-3 text-[15px] text-[#33405e] leading-relaxed">
                  <span className="text-[#6B8AFE] font-black mt-0.5">▪</span>
                  <span className="min-w-0">{satiriIsle(s.slice(2), `l${bi}-${li}`)}</span>
                </li>
              ))}
            </ul>
          );
        }
        if (hepsiSirali) {
          return (
            <ol key={bi} className="space-y-3 pl-1">
              {satirlar.map((s, li) => (
                <li key={li} className="flex gap-3 text-[15px] text-[#33405e] leading-relaxed">
                  <span className="bg-[#6B8AFE] text-white border-2 border-[#0A1A3F] w-6 h-6 flex-shrink-0 flex items-center justify-center font-black text-xs shadow-[2px_2px_0_0_#0A1A3F]">
                    {li + 1}
                  </span>
                  <span className="min-w-0">{satiriIsle(s.replace(/^\d+\.\s/, ""), `o${bi}-${li}`)}</span>
                </li>
              ))}
            </ol>
          );
        }
        return (
          <p key={bi} className="text-[15px] text-[#33405e] leading-relaxed">
            {satiriIsle(b.replace(/\n/g, " "), `p${bi}`)}
          </p>
        );
      })}
    </div>
  );
}
